// removed by extract-text-webpack-plugin
module.exports = {"sectionImg":"_38JE_a5X74uJ_cKOo4hCAd","imgPrez":"cInVVnDQ2Xr7btSHiUaLx"};


//////////////////
// WEBPACK FOOTER
// ./work/sociallyfox/styles.module.css
// module id = 745
// module chunks = 0